import { Outlet, useNavigate } from 'react-router-dom';
import { ReactComponent as MenuSvg } from '../images/menu.svg';
import { ReactComponent as AdminSvg } from '../images/admin.svg';
import { useState } from 'react';
import { MenuItem } from '../components/menuItem';
import './layout.css';
import { useAuth } from '../context/context';

function Layout() {
  const [displayMenu, setDisplayMenu] = useState<boolean>(false);
  const [displayAdmin, setDisplayAdmin] = useState<boolean>(false);
  const { isLoggedIn, isAdmin, logout } = useAuth();
  let navigate = useNavigate();

  return (
    <>
      <nav className="bufete-navbar">
        <div className="navbar-child">
          {isLoggedIn() && (
            <>
              <MenuSvg
                className="interactive-icon"
                onClick={() => setDisplayMenu(!displayMenu)}
              />
              <p className='clickable' onClick={() => navigate('/hoy')}><strong>Lince Legal</strong></p>
            </>
            )}
        </div>
        <p style={{textAlign: 'center'}}>Sistema Bufete Jurídico Universitario</p>
        <AdminSvg
          className="interactive-icon"
          onClick={() => setDisplayAdmin(!displayAdmin)}
        />
      </nav>
      {displayMenu && isLoggedIn() && (
        <div className="bufete-menu">
          <ul>
            <li>
              <MenuItem icon={<MenuSvg />} name="Hoy" route="/hoy" />
            </li>
            <li>
              <MenuItem icon={<MenuSvg />} name="Agenda" route="/agenda" />
            </li>
            <li>
              <MenuItem icon={<MenuSvg />} name="Bitácora" route="/bitacora" />
            </li>
            <li>
              <MenuItem
                icon={<MenuSvg />}
                name="Expedientes"
                route="/expedientes"
              />
            </li>
            <li>
              <MenuItem icon={<MenuSvg />} name="Estadísticas" route="/estadisticas" />
            </li>
          </ul>
        </div>
      )}
      {displayAdmin && (
        <div className="bufete-menu right-menu">
          <ul>
            {!isLoggedIn() && (
              <li>
                <MenuItem icon={<MenuSvg />} name="Ingresar" route="/login" />
              </li>
            )}
            {isAdmin() && (
              <li>
                <MenuItem
                  icon={<MenuSvg />}
                  name="Opciones"
                  route="/opciones"
                />
              </li>
            )}
            {isAdmin() && (
              <li>
                <MenuItem icon={<MenuSvg />} name="Mensaje" route="/mensaje" />
              </li>
            )}
            {isLoggedIn() && (
              <li>
                <MenuItem icon={<MenuSvg />} name="Salir" handleClick={logout} />
              </li>
            )}
          </ul>
        </div>
      )}
      <Outlet />
    </>
  );
}

export default Layout;
